import { RestManager } from '@/newApi/services/rest/RestManager';
import { queryOptions } from '@tanstack/vue-query';
import { useLoginStore } from '@/login/stores/useLoginStore';

interface ApiGenderValues {
    femaleTypes: string[];
    maleTypes: string[];
    notDeclaredTypes: string[];
}

const importService = new RestManager('import-service');

type DataImportOptions = {
    queries: {
        getAcceptedGenderTypes: () => ReturnType<typeof queryOptions<ApiGenderValues, Error>>,
    },
};

export const dataImport: DataImportOptions = {
    queries: {
        getAcceptedGenderTypes: (): ReturnType<typeof queryOptions<ApiGenderValues, Error>> => {
            const { instance } = useLoginStore();
            const url = `/v1/${instance}/get-accepted-gender-types`;
            return queryOptions<ApiGenderValues, Error>({
                queryKey: ['accepted-gender-types', instance, url],
                queryFn: async (): Promise<ApiGenderValues> => {
                    return importService.get<ApiGenderValues>(url);
                },
            });
        },
    },
};
